import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { forEach } from 'ramda';

import { IDLE_TIMEOUT, IDLE_PAYMENT_TIMEOUT } from '../../../modules/idleTimeout/idleTimeout.constants';
import { BookingStep } from '../../../routes/booking/booking.constants';
import { JUDO_ORIGIN } from '../../services/judo';

export const EVENTS = [
  'mousemove',
  'keydown',
  'wheel',
  'DOMMouseScroll',
  'mouseWheel',
  'mousedown',
  'MSPointerDown',
  'MSPointerMove',
  'locationChange',
  'touchstart',
  'touchmove',
  'resetTimeout',
];

export const EVENTS_PAYMENT = ['locationChange', 'resetTimeout'];

export class IdleTimer extends PureComponent {
  static propTypes = {
    isIdle: PropTypes.bool,
    idleChange: PropTypes.func,
    isBookingActive: PropTypes.bool,
    bookingStep: PropTypes.number,
  };

  componentDidMount() {
    this.reset();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isBookingActive !== this.props.isBookingActive || prevProps.bookingStep !== this.props.bookingStep) {
      this.reset();
    }
  }

  componentWillUnmount() {
    this.removeTimeout();
    this.removeEvents();
  }

  get events() {
    if (this.isPayment()) {
      return EVENTS_PAYMENT;
    }
    return EVENTS;
  }

  get timeout() {
    if (this.isPayment()) {
      return IDLE_PAYMENT_TIMEOUT;
    }
    return IDLE_TIMEOUT;
  }

  isPayment = () => this.props.isBookingActive && this.props.bookingStep === BookingStep.PAYMENT;

  reset = () => {
    this.resetTimeout();
    this.resetEvents();
  };

  resetTimeout = () => {
    this.removeTimeout();
    this.idleTimer = setTimeout(this.handleOnIdle, this.timeout);
  };

  removeTimeout = () => {
    clearTimeout(this.idleTimer);
    this.idleTimer = null;
  };

  resetEvents = () => {
    this.removeEvents();
    forEach(e => document.body.addEventListener(e, this.handleOnActive, { passive: true }))(this.events);
    window.addEventListener('message', this.handleIframeMessage);
  };

  removeEvents = () => {
    forEach(e => document.body.removeEventListener(e, this.handleOnActive, { passive: true }))(EVENTS);
    window.removeEventListener('message', this.handleIframeMessage);
  };

  handleIframeMessage = data => {
    if (data.origin === JUDO_ORIGIN) {
      this.handleOnActive();
    }
  };

  handleOnActive = () => {
    if (this.props.isIdle) {
      this.props.idleChange(false);
    }
    this.resetTimeout();
  };

  handleOnIdle = () => {
    if (!this.props.isIdle) {
      this.props.idleChange(true);
    }
  };

  render() {
    return <span />;
  }
}
